
import { useEffect, useState } from "react";
// import { useRouter } from "next/navigation";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useForm } from "react-hook-form";
import { getData, getData2, postData } from "../../../utils/api";
import "./InquiryFormModal.css";
// import SubitFormModal from "../Admission/E-brochure/SubitFormModal/SubitFormModal";
// import ErrorFormModal from "../Admission/E-brochure/ErrorFormModal/ErrorFormModal";
import axios from "axios";
import Cookies from "js-cookie"; // Import js-cookie
import { useNavigate } from "react-router-dom";
import Main_heading_holder from "../common_css/main_heading_holder/Main_heading_holder";
import Common_Form from "../common_form/Common_Form";
const InquiryFormModal = (props) => {


  const handleManualClose = () => {
    Cookies.set("inquiryClosed", "true", { expires: 1 }); // 1-day safety
    props.onHide();
  };

  return (
    <>
      <Modal
        className="inquiry-form-modal modal-dialog-scrollable"
        centered
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
        show={props.show}
        onHide={handleManualClose}
      >
        <Modal.Header className="modal-header-centered" closeButton>
          <Main_heading_holder heading={"  Inquiry "} spanHeading={"Form"} />
        </Modal.Header>
        <Modal.Body>
          <div className="form-sec-start Common_Form">
            <div className="row">
              <span>*Please fill the details below completely</span>
            </div>
           <Common_Form handleManualClose={handleManualClose}/>
          </div>
        </Modal.Body>
      </Modal>
      {/* <SubitFormModal
        show={modalsuccess}
        onHide={() => {
          setModalsuccess(false);
          router.replace("/thank-you");
        }}
      /> */}
      {/* <ErrorFormModal
        show={modalerror}
        onHide={() => {
          setModalError(false);
        }}
      /> */}
    </>
  );
};

export default InquiryFormModal;
